import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../components/utils";

export const usePollBrands = ({ pollId }) => {
  return useQuery({
    queryKey: ["pollsbrands", { pollId }],
    queryFn: async () => {
      return makeApiRequest({
        endpoint: `/api/polls/${pollId}/brands`,
        method: "GET"
      });
    },
    keepPreviousData: true,
    enabled: !!pollId
  });
};

export const usePollBrandsMutation = ({ pollId }) => {
  const queryClient = useQueryClient();

  return {
    create: useMutation(
      async (data) => {
        return makeApiRequest({
          endpoint: `/api/polls/${pollId}/brands`,
          method: "POST",
          body: JSON.stringify(data),
          additionalHeaders: {
            "Content-Type": "application/json"
          }
        });
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: "pollsbrands" });
        }
      }
    ),
    deleteRecord: useMutation(
      async ({ pollBrandId }) => {
        return makeApiRequest({
          endpoint: `/api/polls/${pollId}/brands/${pollBrandId}`,
          method: "DELETE"
        });
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: "pollsbrands" });
        }
      }
    )
  };
};

export const useUpdatePollBrandMutation = ({ pollId }) => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ pollBrandId, data }) => {
      return makeApiRequest({
        endpoint: `/api/polls/${pollId}/brands/${pollBrandId}`,
        method: "PUT",
        body: JSON.stringify(data),
        additionalHeaders: {
          "Content-Type": "application/json"
        }
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: "pollsbrands" });
      }
    }
  );
};
